import { getPayoutDate } from './utils'
import { useIsDesktop } from '~/@mid_ui/layout/useIsDesktop'
import type { ProjectSchema } from '~/@pages_investing/projects/_project_types/project.types'
import { InvestmentSecurity } from '../project-detail_ui/investment-security/InvestmentSecurity'
import { EstablishedPropertyInfo } from '../project-detail_ui/established-property-info/EstablishedPropertyInfo'
import { DebtorInfo } from '../project-detail_ui/debtor-info/DebtorInfo'
import { ProjectAttachments } from '../project-detail_ui/project-attachments/ProjectAttachments'
import { ProjectV1Parameters } from './ProjectV1Parameters'
import { ProjectV1Overview } from './ProjectV1Overview'

type Props = { project: ProjectSchema }

function ProjectV1Detail({ project }: Props) {
  const lastPaymentDate = getPayoutDate(project)

  const isDesktop = useIsDesktop()

  const content = (() => {
    if (isDesktop) {
      return (
        <div className="flex flex-row border-b border-[#969696]">
          <div className="w-[520px] border-r border-[#969696]">
            <ProjectV1Parameters
              project={project}
              lastPaymentDate={lastPaymentDate}
            />
          </div>
          <div className="w-full">
            <Details project={project} />
          </div>
        </div>
      )
    }

    return (
      <>
        <ProjectV1Parameters
          project={project}
          lastPaymentDate={lastPaymentDate}
        />
        <Details project={project} />
      </>
    )
  })()

  return (
    <div className="w-full">
      <ProjectV1Overview project={project} />
      {content}
    </div>
  )
}

type DetailsProps = { project: ProjectSchema }

function Details({ project }: DetailsProps) {
  return (
    <>
      <InvestmentSecurity project={project} />
      <EstablishedPropertyInfo project={project} />
      <ProjectAttachments project={project} />
      <DebtorInfo project={project} />
    </>
  )
}

export { ProjectV1Detail }
